export default __webpack_public_path__ + "static/media/fast-backward.11a0d79d.svg";